import { a as appGlobalScript } from './ionic-global-9d5c8ee3.js';

const globalScripts = appGlobalScript;

export { globalScripts as g };
